import memoize from 'lodash/memoize';
export const hashString = memoize(str => String(str.split('').reduce((prevHash, currVal) => (prevHash << 5) - prevHash + currVal.charCodeAt(0), 0)));
export default hashString;